export const environment = {
  production: true,
  buildId: '2740180210518741',
  configFile: 'config.json',
};
